import styled from 'styled-components'

export const NavigationTree = styled.div`
    /*
     * NavigationTreeRow is a copy of the original react-sortable-tree row renderer, so it is styled
     * with that library's row rules (restored here). @nosferatu500/react-sortable-tree ships
     * different rules for the same class names, so the properties it adds are reset as well.
     */
    .rst__rowWrapper {
        display: block;
        padding: 10px 10px 10px 0;
        height: 100%;
        box-sizing: border-box;
    }

    .rst__row {
        height: 100%;
        white-space: nowrap;
        display: flex;
    }

    .rst__rowContents {
        position: relative;
        height: 100%;
        border: solid #bbb 1px;
        border-left: none;
        box-shadow: 0 2px 2px -2px;
        padding: 0 5px 0 10px;
        border-radius: 2px;
        min-width: 230px;
        flex: 1 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0;
        background-color: white;
    }

    .rst__rowContentsDragDisabled {
        border-left: solid #bbb 1px;
    }

    .rst__rowLabel {
        flex-direction: row;
        padding-right: 20px;
    }

    .rst__rowToolbar {
        gap: 0;
    }

    .rst__toolbarButton {
        display: inline-block;
        vertical-align: middle;
    }

    .rst__rowTitle {
        font-weight: bold;
    }

    .rst__moveHandle,
    .rst__loadingHandle {
        height: 100%;
        width: 44px;
        background: #d9d9d9
            url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+')
            no-repeat center;
        border: solid #aaa 1px;
        box-shadow: 0 2px 2px -2px;
        cursor: move;
        border-radius: 1px;
        z-index: 1;
    }

    .rst__loadingHandle {
        cursor: default;
        background: #d9d9d9;
    }

    .rst__collapseButton,
    .rst__expandButton {
        appearance: none;
        border: none;
        position: absolute;
        border-radius: 100%;
        box-shadow: 0 0 0 1px #000;
        width: 16px;
        height: 16px;
        padding: 0;
        top: 50%;
        translate: none;
        transform: translate(-50%, -50%);
        cursor: pointer;

        &:focus {
            outline: none;
            box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;
        }

        &:hover:not(:active) {
            background-size: 24px;
            height: 20px;
            width: 20px;
        }
    }

    .rst__collapseButton {
        background: #fff
            url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==')
            no-repeat center;
    }

    .rst__expandButton {
        background: #fff
            url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+')
            no-repeat center;
    }

    .rst__lineChildren {
        height: 100%;
        display: inline-block;
        position: absolute;

        &::after {
            content: '';
            position: absolute;
            background-color: black;
            width: 1px;
            left: 50%;
            bottom: 0;
            height: 10px;
        }
    }

    .rst__nodeContent {
        right: 0;
    }

    .rst__rowToolbar,
    .rst__rowLabel {
        flex: 1;
        display: flex;
        align-items: center;
    }

    .rst__rowLabel {
        justify-content: space-between;
    }

    .rst__rowToolbar {
        justify-content: flex-end;
    }

    .rst__rowSubtitle {
        font-size: 85%;
        line-height: inherit;
        font-weight: normal;
        white-space: pre;
    }

    .rst__moveHandle {
        min-width: 44px;
    }
`
